import { render, staticRenderFns } from "./UsernameItem.vue?vue&type=template&id=34387bb6"
import script from "./UsernameItem.vue?vue&type=script&lang=js"
export * from "./UsernameItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports